import React from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from './use-toast';

// Same public route and sharing behavior previously used by ProfilePage.
// Never include the current query string, session information or private content.
export const buildProfileShareUrl = (username) => username
  ? new URL(`/u/${encodeURIComponent(username)}`, process.env.REACT_APP_BACKEND_URL).href
  : '';

export const useProfileShare = (username) => {
  const { t } = useTranslation('profile');
  const { toast } = useToast();
  const url = buildProfileShareUrl(username);

  const notifyCopy = (success) => toast({
    title: <span data-testid="profile-share-feedback-title">{t(success ? 'share.copied_title' : 'share.copy_error')}</span>,
    description: <span className="select-text break-all" data-testid="profile-share-feedback-link">{url}</span>,
  });

  const copyProfileLink = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      notifyCopy(true);
    } catch {
      // Keep the existing manual-copy fallback when clipboard access is denied.
      notifyCopy(false);
    }
  };

  const shareProfile = async () => {
    if (!url) return;
    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title: `@${username} · Nymia`, url });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }
    await copyProfileLink();
  };

  return { shareProfile, copyProfileLink };
};